
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","width":"201","height":"385","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-447.971 621.126l279.097-644.073a33.36 33.36 0 0128.203-20.001 33.354 33.354 0 0130.787 15.75l54.23 87.84 109.749-161.16a33.378 33.378 0 0128.32-14.574 33.392 33.392 0 0127.637 15.834l85.129 137.89a33.354 33.354 0 01-.673 36.09L-25.976 403.862a33.382 33.382 0 01-28.33 14.788 33.361 33.361 0 01-27.767-15.829l-55.058-89.182L-390.607 654.3c-10.11 13.594-28.8 17.44-43.46 8.971a33.32 33.32 0 01-11.675-11.334c-5.568-9.018-6.711-20.483-2.236-30.806l.007-.005z"}})])
          )
        }
      }
    